module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Disclosures","desc":"Get access to price-sensitive market information, including quarterly or annual financial statements from listed companies"},"ar":{"title":"الإفصاحات","desc":"اطلع على المعلومات المؤثرة على حركة الأسعار في السوق، بما فيها البيانات المالية الفصلية والسنوية الصادرة عن الشركات المدرجة."}}')
  delete Component.options._Ctor
}
